import { RootState } from "integrations/redux"
import { HotspotMultiSelectSliceName } from "./slice"
import { createSelector } from "@reduxjs/toolkit"
import { HotspotWithLabel } from "@nova/constants"

const root = (state: RootState) => state[HotspotMultiSelectSliceName]

export const selectIsHotspotMultiRemovalOpen = (state: RootState) => root(state).multiRemovalOpen
export const selectHotspotMultiSelectFlight = (state: RootState) => root(state).infraredFlightId
export const selectMultiSelectHotspots = (state: RootState) => root(state).hotspots
export const selectSelectedHotspots = (state: RootState) => root(state).hotspots
export const selectSelectedHotspotsMap = createSelector([selectSelectedHotspots], (hotspots) =>
    hotspots.reduce(
        (prev, curr) => {
            prev[curr.id] = curr
            return prev
        },
        {} as Record<string, HotspotWithLabel>
    )
)
